import React, { Component } from "react";
import { Formik } from "formik";
import InputFieldText from "components/utility/input-field/InputFieldText";
import ButtonAction from "components/utility/button/ButtonAction";
import ImageChecked from "components/utility/images/ImageChecked";
import validation from "components/utility/validation/validation";
import Checkbox from "components/utility/checkbox/Checkbox";
import { getDecodedHtml } from "utils/getDecodedHtml";
import MaterialBoxGatedEmailModalFooter from "./MaterialBoxGatedEmailModalFooter";

class MaterialBoxGatedEmailForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			disabled: "true",
			checkBoxChecked: false,
			emailSent: false
		};
		this.acceptedRef = React.createRef();
	}

	validate = (values = {}) => {
		let errors = {};
		const { data = {} } = this.props;
		const { modal = {} } = data;
		const { name = {}, email = {} } = modal;

		for (var key in values) {
			if (!values[key]) {
				if (key === "name" && name.isRequired) {
					errors[key] = name.errors.required;
				}
				if (key === "email" && email.isRequired) {
					errors[key] = email.errors.required;
				}
			} else if (key === "email" && !validation("email", values[key])) {
				errors[key] = email.errors.invalid;
			}
		}
		if (Object.entries(errors).length === 0 && this.acceptedRef.current.checked) {
			this.setState({ disabled: false });
		} else {
			this.setState({ disabled: true });
		}
		return errors;
	};
	successSent = () => {
		this.setState({ emailSent: true });
		this.setState({ disabled: true });
		this.props.displayCheckedFields();
	};
	errorMessage = (errorMessage) => {
		this.props.errorMessage(errorMessage);
	};

	render() {
		const { data = {} } = this.props;
		const {
			name = {},
			email = {},
			affirmation = {},
			successMessage = {},
			postFormDataApiUrl,
			nonce,
			id
		} = data.modal;
		const { buttonLabel, buttonFill, dataAction, dataCategory, dataLabel } = data.modal.button;
		const { disabled } = this.state;
		return this.props.data ? (
			<Formik
				initialValues={{
					name: "",
					email: "",
					checkBoxChecked: false
				}}
				validate={this.validate}
				onSubmit={(values) => {
					values.nonce = nonce;
					values.id = id;
					delete values.checkBoxChecked;
					fetch(postFormDataApiUrl, {
						headers: { "Content-Type": "application/json" },
						method: "POST",
						credentials: "same-origin",
						body: JSON.stringify(values)
					})
						.then((response) => {
							if (response.ok) return response.json();
							throw new Error(response.statusText);
						})
						.then(
							function (response) {
								if (response === true) {
									this.successSent();
								} else {
									this.errorMessage();
								}
							}.bind(this)
						)
						.catch(function (error) {
							console.log(error);
						});
				}}
			>
				{({ values, errors, handleChange, handleSubmit, handleBlur, touched }) => (
					<form onSubmit={handleSubmit}>
						{this.state.emailSent === false ? (
							<InputFieldText
								label={name.label + (name.isRequired === "true" ? " *" : "")}
								type="text"
								name="name"
								value={values.name}
								handleChange={handleChange}
								formikHandleBlur={handleBlur}
								touched={touched.name}
								error={errors.name}
								className="col-6_sm-12"
							/>
						) : (
							<div className="material-email-modal-form-check">
								<span
									className="material-email-modal-form-label"
									onClick={this.handleLabelClick}
									onKeyUp={this.keyHandler}
									role="presentation"
								>
									{name.label + (name.isRequired === "true" ? " *" : "")}
								</span>
								<div className="material-email-modal-form-table">
									<span className="material-email-modal-form-table-value">{values.name}</span>
									<span className="material-email-modal-form-table-image">
										<ImageChecked />
									</span>
								</div>
							</div>
						)}

						{this.state.emailSent === false ? (
							<InputFieldText
								label={email.label + (email.isRequired === "true" ? " *" : "")}
								type="email"
								name="email"
								value={values.email}
								handleChange={handleChange}
								formikHandleBlur={handleBlur}
								touched={touched.email}
								error={errors.email}
								className="col-6_sm-12"
							/>
						) : (
							<div className="material-email-modal-form-check">
								<span
									className="material-email-modal-form-label"
									onClick={this.handleLabelClick}
									onKeyUp={this.keyHandler}
									role="presentation"
								>
									{email.label + (email.isRequired === "true" ? " *" : "")}
								</span>
								<div className="material-email-modal-form-table">
									<span className="material-email-modal-form-table-value">{values.email}</span>
									<span className="material-email-modal-form-table-image">
										<ImageChecked />
									</span>
								</div>
							</div>
						)}
						{this.state.emailSent === false ? (
							<div>
								<Checkbox
									id={"checkboxChecked"}
									value={this.state.checkBoxChecked}
									checked={this.state.checkBoxChecked}
									onChange={() => {
										this.validate(values);
									}}
									reference={this.acceptedRef}
								/>
								<label
									htmlFor={"checkboxChecked"}
									className="no-select"
									value={affirmation.label}
									dangerouslySetInnerHTML={{ __html: getDecodedHtml(affirmation.label) }}
								></label>
							</div>
						) : (
							""
						)}
						<div className="contact-us-button ">
							<ButtonAction
								type={buttonFill}
								width="auto"
								label={this.state.emailSent === false ? buttonLabel : successMessage.buttonText}
								isButton="true"
								buttonType="submit"
								disabled={disabled ? true : false}
								dataA="true"
								dataALbl={dataLabel}
								dataACat={dataCategory}
								dataAAct={dataAction}
							/>
						</div>
						<MaterialBoxGatedEmailModalFooter
							data={this.props.data}
							emailSent={this.state.emailSent}
						/>
					</form>
				)}
			</Formik>
		) : (
			""
		);
	}
}

export default MaterialBoxGatedEmailForm;
